<ng-container *ngIf="interactiveWidgets">
  <div *ngFor="let widget of interactiveWidgets">
    <eds-cta-basic
      *ngIf="widget.isFirmAllowed && !isBypassUser"
      [theme]="widget.theme"
      [hasImg]="!!widget?.imgSrc"
      [imgSrc]="widget?.imgSrc"
      [class]="'interactive-widgets__cta-interactive-widget'"
    >
      <ng-container>
        <div
          class="interactive-widgets-interactive-content"
          [innerHTML]="widget?.description?.value | safeHtml"
        ></div>
        <ft-pcs-tool
          *ngIf="widget?.interactiveConfigImpl && widget?.interactiveConfigImpl"
          [pcsConfig]="widget.interactiveConfigImpl"
          [pcsLabels]="widget.labelsImpl"
          [class]="'interactive-widgets__pcs-tool-interactive-widget'"
        ></ft-pcs-tool>
      </ng-container>
    </eds-cta-basic>
  </div>
</ng-container>
